import { render, staticRenderFns } from "./OnboardingTermsAndCondition.vue?vue&type=template&id=66887b92&"
import script from "./OnboardingTermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./OnboardingTermsAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports